document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".sansu-product-content").forEach(group => {

    const items = group.querySelectorAll(".sansu-accordion-item");

    items.forEach(item => {

      const header = item.querySelector(".sansu-accordion-header");

      header.addEventListener("click", () => {

        items.forEach(other => {
          if (other !== item) {
            other.classList.remove("active");
          }
        });

        item.classList.toggle("active");

      });

    });

  });

});